import React from 'react';
import { CreatePage } from '@components/common';
import TagForm from '@components/common/forms/TagForm';

const TagCreatePage = () => {
    return (
        <CreatePage
            modelName="tags"
            FormComponent={TagForm}
        />
    );
};

export default TagCreatePage;
